import { render } from "./ExceptionReviewedCases.vue?vue&type=template&id=108346fa"
import script from "./ExceptionReviewedCases.vue?vue&type=script&lang=js"
export * from "./ExceptionReviewedCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ExceptionReviewedCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "108346fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('108346fa', __exports__)) {
    console.log('reload')
    api.reload('108346fa', __exports__)
  }
  
  module.hot.accept("./ExceptionReviewedCases.vue?vue&type=template&id=108346fa", () => {
    console.log('re-render')
    api.rerender('108346fa', render)
  })

}


export default __exports__